// extracted by mini-css-extract-plugin
export default {"header":"MyEvaluation_header__w0vNy"};